import { useSyncExternalStore } from 'react';

// Fuera de STORAGE_KEYS a propósito: clearSession() borra esas claves al cerrar
// sesión, y el modo claro/oscuro es del equipo, no de la cuenta.
const KEY = 'dragonTheme';

// Quien necesite enterarse del cambio fuera del árbol de la página (la ventana
// del panel flotante es OTRO documento y no ve el data-theme de este).
const listeners = new Set();

export const getTheme = () => (document.documentElement.dataset.theme === 'light' ? 'light' : 'dark');

export function initTheme() {
  document.documentElement.dataset.theme = localStorage.getItem(KEY) === 'light' ? 'light' : 'dark';
}

export function setTheme(theme) {
  document.documentElement.dataset.theme = theme;
  localStorage.setItem(KEY, theme);
  listeners.forEach((fn) => fn());
}

const subscribe = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export function useTheme() {
  return useSyncExternalStore(subscribe, getTheme, getTheme);
}

// Logo dorado sobre fondo oscuro, negro sobre fondo claro.
export function useLogo() {
  return useTheme() === 'light' ? '/logo-light.png' : '/logo-dark.png';
}
